export default __webpack_public_path__ + "static/gg-6f463f63ca89888e27733aa8914b4f9a.svg";